import React from "react";

export const UserDetails = () => {
  return <div>UserDetails</div>;
};
